import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ApmTranslatePipe, UserSettingsFacade } from '@mitsubishi/core';
import { StudyUnitAccessoryWithPrice } from '@mitsubishi/shared/data-access';
import { ApmCurrencyPipe, BaseUiModule, ButtonComponent } from '@mitsubishi/shared/ui';

import { LetDirective } from '@ngrx/component';

import { ApmAccessoryNamePipe } from '../pipes/accessory-name.pipe';
import { ApmProjectCurrencyPipe } from '../pipes/apm-project-currency.pipe';

export type UnitAccessoriesListDialogData = {
  unitModelName: string;
  accessories: StudyUnitAccessoryWithPrice[];
};

@Component({
  selector: 'apm-unit-accessory-list-dialog',
  templateUrl: './unit-accessory-list-dialog.component.html',
  styleUrls: ['./unit-accessory-list-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ApmProjectCurrencyPipe,
    ApmTranslatePipe,
    ButtonComponent,
    LetDirective,
    ApmAccessoryNamePipe,
    BaseUiModule,
  ],
  providers: [ApmCurrencyPipe],
})
export class UnitAccessoryListDialogComponent {
  showPrices$ = this.userSettingsFacade.showPrices$;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UnitAccessoriesListDialogData,
    public dialogRef: MatDialogRef<UnitAccessoryListDialogComponent>,
    private userSettingsFacade: UserSettingsFacade
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
